import { placeSideDockTab } from "@loot-os/design-system/core/useSideDock";
import type { RefObject } from "react";

import { lazyOverlay, useLazyOverlay, usePreloadWhenIdle } from "../../lib/lazyOverlay.js";

const StoreChatRoom = lazyOverlay(() =>
  import("./StoreChatRoom.js").then((module) => module.StoreChatRoom),
);

/**
 * What the side dock holds where the theme docks chat: the room, headless, in its own chunk. It
 * loads the first time the dock opens (at once on a wide screen, where it opens docked) or once
 * the page is idle, and stays mounted after it closes. The dock's tab follows its foot row.
 */
export function StoreChatDockPanel({
  open,
  onClose,
  panel,
}: {
  open: boolean;
  onClose: () => void;
  /** The dock's panel, which the tab is placed on. */
  panel: RefObject<HTMLElement | null>;
}) {
  usePreloadWhenIdle(StoreChatRoom);
  const Room = useLazyOverlay(StoreChatRoom, open, onClose);
  return (
    Room && <Room headless onTabMiddle={(middle) => placeSideDockTab(panel.current, middle)} />
  );
}
